<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI TÀI KHOẢN</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT TÀI KHOẢN</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT TÀI KHOẢN</h3>
      </div>
      <div class="card-body">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-position="top"
        >
          <b-row>
            <b-col :md="mData.viewMode === 'detail' ? 6 : 3">
              <el-form-item label="Tài khoản" prop="account">
                <el-input
                  type="text"
                  v-model="ruleForm.account"
                  :disabled="
                    mData.viewMode === 'detail' || mData.viewMode === 'update'
                  "
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly')"
                  @change="fn_changeAccount()"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="3" v-show="mData.viewMode !== 'detail'">
              <el-form-item
                label="Mật khẩu"
                :prop="mData.viewMode === 'create' ? 'pass' : ''"
              >
                <el-input
                  type="password"
                  v-model="ruleForm.pass"
                  show-password
                  @input="forceUpdateUI"
                  autocomplete="off"
                  @change="fn_changePass"
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="3" v-show="mData.viewMode !== 'detail'">
              <el-form-item
                label="Nhập lại mật khẩu"
                :prop="mData.viewMode === 'create' ? 'checkPass' : ''"
              >
                <el-input
                  type="password"
                  v-model="ruleForm.checkPass"
                  show-password
                  @input="forceUpdateUI"
                  autocomplete="off"
                  @change="fn_changeCheckPass"
                  :disabled="!ruleForm.pass"
                ></el-input>
                <p class="user-error" v-show="isCheckPassError">
                  {{ errorMessCheckPass }}
                </p>
              </el-form-item>
            </b-col>

            <b-col :md="mData.viewMode === 'detail' ? 6 : 3">
              <el-form-item label="Quyền tài khoản" prop="roles">
                <el-select
                  v-model="ruleForm.roles"
                  multiple
                  placeholder="Chọn quyền"
                  :disabled="mData.viewMode === 'detail' || (mData.viewMode === 'update' && (ruleForm.roles.includes('FamilyAdmin') || ruleForm.roles.includes('FamilyUser')))"
                  clearable
                >
                  <el-option
                    v-for="item in optionRoles"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item label="Trạng thái tài khoản">
            <el-radio-group v-model="radio" class="d-flex mt-3">
              <el-radio
                :label="true"
                class="mr-3"
                :disabled="mData.viewMode === 'detail'"
                >Tài khoản bị khóa</el-radio
              >
              <el-radio :label="false" :disabled="mData.viewMode === 'detail'"
                >Tài khoản đang hoạt động</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormUser";
import { Circle4 } from "vue-loading-spinner";

export default {
  components: {
    Circle4,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Vui lòng nhập giá trị"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Vui lòng nhập lại mật khẩu"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("Mật khẩu không trùng khớp"));
      } else {
        callback();
      }
    };
    return {
      aLang: LanguageService.lang,
      dynamicTags: [],
      loading: true,
      radio: false,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
      options: MethodService.copyObject(DataForm.options),
      optionRoles: MethodService.copyObject(DataForm.optionsRoles),
      allUser: [],
      ruleForm: {
        account: "",
        pass: "",
        checkPass: "",
        roles: [],
      },
      rules: {
        account: [ValidService.required, ValidService.checkAccount],
        pass: [
          ValidService.required,
          ValidService.checkPassFull,
          { validator: validatePass, trigger: "blur" },
        ],
        checkPass: [
          ValidService.required,
          ValidService.checkPassFull,
          { validator: validatePass2, trigger: "blur" },
        ],
        roles: [ValidService.required, ValidService.requiredChange],
        optionRoles: [ValidService.required],
      },
      isCheckPassError: false,
      isPassError: false,
      errorMessCheckPass: "",
      passOld: "",
      isNotInputPass: true,
    };
  },
  methods: {
    async fn_initForm() {
      try {
        const response = await mushroom.user.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields: "id,account,disabled,roles",
        });
        this.ruleForm = response.result;
        this.radio = response.result.disabled;
        this.dynamicTags = response.result.roles;
        console.log("Thông tin user trả về: %o", response.result);
        console.log(this.dynamicTags);
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // thêm mới tài khoản
    async fn_add() {
      const user_object = {
        account: this.ruleForm.account,
        password: this.ruleForm.pass,
        disabled: this.radio,
        roles: this.ruleForm.roles,
      };
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          if (!user_object.roles.includes("User")) {
            user_object.roles.push("User");
          }
          if (!this.allUser.includes(user_object.account)) {
            try {
              await mushroom.user.createAsync(user_object);
              window.toastr.success("Thêm mới tài khoản thành công");
              MethodService.stopLadda();
              this.fn_resetForm();
            } catch (e) {
              MethodService.stopLadda();
              console.error("Có lỗi: %o", e);
              if (e.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (e.code === 2) {
                window.toastr.error("Máy chủ không phản hồi");
              } else window.toastr.error("Đã có lỗi xảy ra");
            }
          } else {
            MethodService.stopLadda();
            window.toastr.error("Tài khoản đã tồn tại");
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    // lấy về danh sách các tài khoản để check thêm mới
    async fn_getAllUser() {
      try {
        const response = await mushroom.user.listAsync({
          limit: 1000,
        });
        response.result.forEach((item) => {
          this.allUser.push(item.account);
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // cập nhật tài khoản
    async fn_update() {
      const user_object = {
        id: this.$router.currentRoute.params.id,
        account: this.ruleForm.account,
        password: this.ruleForm.pass,
        disabled: this.radio,
        roles: this.ruleForm.roles,
      };
      console.log(user_object);
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          if (!user_object.roles.includes("User")) {
            user_object.roles.push("User");
          }
          console.log(this.ruleForm.pass, this.ruleForm.checkPass);
          if (this.ruleForm.pass) {
            if (this.ruleForm.checkPass !== this.ruleForm.pass) {
              this.isCheckPassError = true;
              this.errorMessCheckPass = "Mật khẩu không trùng khớp";
              MethodService.stopLadda();
            } else {
              this.isCheckPassError = false;
              this.errorMessCheckPass = "";
              await this.fn_updateApiUser(user_object);
            }
          } else if (
            !this.ruleForm.pass &&
            this.ruleForm.checkPass !== this.ruleForm.pass
          ) {
            this.isCheckPassError = true;
            this.errorMessCheckPass = "Mật khẩu không trùng khớp";
            MethodService.stopLadda();
            return false;
          } else {
            await this.fn_updateApiUser(user_object);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    async fn_updateApiUser(user_object) {
      try {
        const response = await mushroom.user.partialUpdateAsync(user_object);
        if (response.result == this.$router.currentRoute.params.id) {
          window.toastr.success("Cập nhật thông tin người dùng thành công");
          MethodService.stopLadda();
          this.$router.go(-1);
        } else {
          window.toastr.warning("Dữ liệu không thay đổi");
          MethodService.stopLadda();
        }
      } catch (error) {
        MethodService.stopLadda();
        console.error("Có lỗi: %o", error);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        }
      }
    },

    fn_changeCheckPass() {
      this.isCheckPassError = false;
      this.errorMessCheckPass = "";
    },
    fn_changePass(event) {
      this.isNotInputPass = false;
    },

    fn_changeAccount() {
      this.ruleForm.account = this.ruleForm.account.toLowerCase();
    },

    // quay lại danh sách slide
    fn_back() {
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
      if(this.ruleForm.pass === '' || !this.ruleForm.pass) {
        this.ruleForm.checkPass = '';
      }
    },
    fn_resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
  },
  async created() {
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "ThemMoiNguoiDung") {
      this.mData.viewMode = "create";
      this.fn_getAllUser();
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietNguoiDung") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatNguoiDung") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.el-tag {
  font-size: 16px;
}
.user-error {
  color: #f56c6c;
  font-size: 13px;
}
</style>
